import { GatewayApiClient } from "@radixdlt/babylon-gateway-api-sdk";
import { RADIX_GATEWAY_URL } from "~/lib/util";

export const useGatewayApi = GatewayApiClient.initialize({
	basePath: RADIX_GATEWAY_URL,
	applicationName: 'HUG'
});

